import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { type BoxProps, styled } from '@mui/material';
import { SxProps } from '@mui/system';

export type EmptyBoxProps = {
    text: string;
    subText?: string;
    sx?: SxProps;
} & BoxProps;

export const EmptyBox: React.FunctionComponent<EmptyBoxProps> = styled((props: EmptyBoxProps) => {
    const { text, subText } = props;

    return (
        <Box
            {...props}
            data-testid="emptybox"
        >
            <Typography
                variant="overline"
                color="text.secondary"
                sx={{
                    marginLeft: '2%',
                    marginRight: '2%',
                }}
            >
                {text}
            </Typography>
            {subText ? (
                <Typography
                    variant="overline"
                    color="text.secondary"
                    sx={{
                        marginLeft: '2%',
                        marginRight: '2%',
                    }}
                >
                    {subText}
                </Typography>
            ) : null}
        </Box>
    );
})(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderStyle: 'dashed',
    borderRadius: '10px',
    borderWidth: '1px',
    borderColor: `${theme.palette.grey[500]}`,
    width: '100%',
    height: '100%',
    minWidth: '200px',
    minHeight: '100px',
}));
